import { GroupLottoItemProps } from './GroupLotto.types'
import { LottoGameCardGrid } from '../LottoGameCard'

const GroupLotto: React.FC<GroupLottoItemProps> = ({ name, items }) => {
  return (
    <>
      <h3 className="text-[var(--heading-text)] mt-4">{name}</h3>
      <LottoGameCardGrid items={items} />
    </>
  )
}

export default GroupLotto
